import _ from 'lodash';

function pathJoin(...parts) {
  const separator = '/';
  const replace = new RegExp(`${separator}{1,}`, 'g');
  return parts.join(separator).replace(replace, separator);
}

export default class UrlHelper {
  constructor(url) {
    this.url = url;
  }

  static networkScopedUrl(...url) {
    const networkId = $('#network-id').data('network-id');
    if (!networkId) { return pathJoin(url); }
    return pathJoin(`/network/${networkId}`, ...url);
  }

  baseUrl() {
    const [url] = this.url.split('?');
    return url;
  }

  queryString() {
    const [, queryString] = this.url.split('?');
    return queryString;
  }

  params() {
    const query = this.queryString();
    if (!query) {
      return { };
    }

    return _(/^[?#]/.test(query) ? query.slice(1) : query)
      .split('&')
      .reduce((params, param) => {
        const [key, value] = param.split('=');
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''; // eslint-disable-line no-param-reassign
        return params;
      }, { });
  }

  urlWithParams(params) {
    return `${this.baseUrl()}?${_.map(params, (value, key) => `${key}=${value}`).join('&')}`;
  }

  urlByAppendingParams(params) {
    return this.urlWithParams(_.extend(this.params(), params));
  }
}
